import { render, staticRenderFns } from "./ModalStateBedReport.vue?vue&type=template&id=70d78b3e&scoped=true&"
import script from "./ModalStateBedReport.vue?vue&type=script&lang=js&"
export * from "./ModalStateBedReport.vue?vue&type=script&lang=js&"
import style0 from "./ModalStateBedReport.vue?vue&type=style&index=0&id=70d78b3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d78b3e",
  null
  
)

export default component.exports